
import HospitalbackstageList from './list.vue'


let a = Object.assign({ HospitalbackstageList})
export default a

